import React from "react"
import ReactDOM from "react-dom"
import store from "app/store"
import { Provider, } from "react-redux"
import "./index.css"
import App from "./app/App"
import reportWebVitals from "./reportWebVitals"
import { createMuiTheme, ThemeProvider, } from "@material-ui/core/styles"
import style from "./style.module.scss"

// mappedin経由でthree.jsのwarnが大量に出ているため
console.warn = () => {}

// Material UIのコンポーネントの見た目を変更するためのテーマ
const theme = createMuiTheme({
  palette: {
    primary: {
      main: style.primaryMain,
    },
    secondary: {
      main: style.secondaryMain,
    },
  },
})

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
